import { action } from 'satcheljs';

// Action which is called when Echo Suppression option is changed.
export const onEchoSuppresionChanged = action(
    'onEchoSuppresionChanged',
    (selectedOption: boolean) => ({
        selectedOption,
    })
);

// Action which is called to discard Group option changes.
export const discardGroupOptions = action('discardGroupOptions');
